import React from 'react'
import { Card } from "../../components/Card/Card";
import { Loading } from "../../components/Loading/Loading";
import parse from "html-react-parser";

export const Loader = () => {
  return (
    <div className="container --small">
          <Loading name="money-hand-icons" />

          <Card
            type="card-quote"
            iconName="quote"
            title="È bello starti vicino."
            customClasses="mBottom3x"
            subtitle={parse(
              "Perché progettare è semplice,<br>realizzare ancora di più."
            )}
            description={parse(
              "Oggi noi abbiamo detto 100 volte sì.<br>Oggi voi avete realizzato 100 progetti di vita.<br /><span class='text-color-primary dBlock mTop2x'>Stiamo elaborando i tuoi dati, funzionali alla valutazione della richiesta di credito</span>"
            )}
          />
        </div>
  )
}
